import { apiClient } from './client';

export interface CurrentTerms {
  version: number;
  content: string;
  publishedAt: string;
}

/**
 * Fetches the currently-published Terms & Conditions (MYN-33) for
 * `TermsModal`, replacing the previously-hardcoded terms copy.
 */
export async function fetchCurrentTerms(): Promise<CurrentTerms> {
  const { data } = await apiClient.get<CurrentTerms>('/content/terms');
  return data;
}

/**
 * Records the current user's acceptance of the currently-published Terms
 * (MYN-33), clearing `needsTermsReconsent` on the session. Used by
 * `TermsReconsentGate`. The endpoint is idempotent, so a duplicate accept
 * (e.g. two open tabs) is safe to retry.
 */
export async function acceptTerms(): Promise<void> {
  await apiClient.post('/content/terms/accept');
}
